<!-- TODO: add shared state -->
<isophi-app-portfolio-plan-base-item
  #base
  *transloco="let t"
  [leftIcon]="'sticky_note_2'"
  [title]="t('portfolio/notes')"
  [shared]="recordTypeEnum.Private"
>
  <div *ngIf="base.mode === base.modeEnum.VIEW && !!control.value" class="note-text">{{ control.value }}</div>
  <div *ngIf="base.mode === base.modeEnum.EDIT">
    <textarea
      class="custom-textarea note-textarea mb-2"
      [placeholder]="t('planDetail/description')"
      cdkTextareaAutosize
      cdkAutosizeMinRows="4"
      [formControl]="control"
    ></textarea>

    <div class="actions d-flex justify-content-end">
      <button (click)="cancel(); base.mode = base.modeEnum.VIEW" class="btn btn-light-outline">
        {{ t('common/cancel') }}
      </button>

      <button (click)="save(); base.mode = base.modeEnum.VIEW" class="btn btn-primary">
        {{ t('common/save') }}
      </button>
    </div>
  </div>
</isophi-app-portfolio-plan-base-item>
